import { TranslationService } from './../../services/translation.service';
import { Component, OnInit, Inject } from '@angular/core';
import { SportingEvent } from '../../models/sportingEvent';
import { MD_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-translate-classification-modal',
  templateUrl: './translate-classification-modal.component.html',
  styleUrls: ['./translate-classification-modal.component.scss']
})
export class TranslateClassificationModalComponent implements OnInit {

  translationType: number;
  elementExternalId: number;
  translationKey: string;
  sportingEvents: SportingEvent[];
  loading: boolean;

  constructor(@Inject(MD_DIALOG_DATA) public data: any,
    private translationService: TranslationService,
    private router: Router) {
    const state = this.router.routerState;
    if (state.snapshot['_root'].children['0'].children['0'] && state.snapshot['_root'].children['0'].children['0'].value.params.id) {
      this.translationType = state.snapshot['_root'].children['0'].children['0'].value.params.id;
    }
    this.elementExternalId = data.id;
    this.translationKey = data.key;
  }

  ngOnInit() {
    this.getSportingEvents();
  }

  getSportingEvents() {
    this.loading = true;
    this.sportingEvents = [];
    this.translationService.getSportingEvents(this.translationType, this.elementExternalId).subscribe((sportingEvents) => {
      this.sportingEvents = sportingEvents;
      this.loading = false;
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/modals/translate-classification-modal/translate-classification-modal.component.ts